import { Add } from "@mui/icons-material";
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import React from "react";
import {
  Button,
  Create,
  CreateBase,
  Datagrid,
  DeleteButton,
  FunctionField,
  List,
  NumberInput,
  ReferenceField,
  required,
  SaveButton,
  SearchInput,
  SimpleForm,
  TextField,
  TextInput,
  TopToolbar,
  useListContext,
  useNotify,
  useRefresh,
  useUnselectAll,
} from "react-admin";
import EmailWithCopy from "../components/EmailWithCopy";
import LocalisedDateField from "../components/localisedDateField";

const FreeSubscriptionDatagrid = (props: any) => {
  const userColumns = [
    <ReferenceField
      source="userId"
      reference="users"
      link={(record: any, reference: any) => `/${reference}/${record.id}/show/subscriptions`}
    >
      <FunctionField render={(record: any) => `${record.firstName} ${record.lastName}`} />
    </ReferenceField>,
    <EmailWithCopy source="userEmail" />,
  ];
  return (
    <Datagrid {...props}>
      {props.showUserColumns ? userColumns : null}
      <LocalisedDateField field="subscriptionStart" label="Subscription Start" />
      <LocalisedDateField field="subscriptionEnd" label="Subscription End" />
      <TextField source="source" />
      <DeleteButton redirect="" />
    </Datagrid>
  );
};

const FreeSubscriptionFilters = [
  <SearchInput source="user_email__icontains" alwaysOn={true} placeholder="User Email" />,
];
export const FreeSubscriptionList = () => {
  return (
    <List
      resource="freeSubscriptions"
      sort={{ field: "subscriptionStart", order: "DESC" }}
      filters={FreeSubscriptionFilters}
    >
      <FreeSubscriptionDatagrid bulkActionButtons={false} showUserColumns={true} />
    </List>
  );
};

const FreeSubscriptionCreateForm = (props: any) => {
  let sx = { width: "50%" };
  return (
    <SimpleForm toolbar={false} {...props} id="free-sub-create-form">
      <TextInput source="userEmail" validate={[required()]} sx={sx} type="email" />
      {/*<DateInput source="subscriptionStart" validate={[required()]} defaultValue={new Date()} sx={sx} />*/}
      {/*<DateInput source="subscriptionEnd" validate={[required()]} sx={sx} />*/}
      <NumberInput source="freeMonthCount" max={12} min={1} defaultValue={1} label="Free months" />
      <SaveButton form="free-sub-create-form" alwaysEnable />
    </SimpleForm>
  );
};

export const FreeSubscriptionCreate = () => {
  return (
    <Create>
      <FreeSubscriptionCreateForm />
    </Create>
  );
};
const UserFreeSubscriptionCreateDialogButton = ({ record }: any) => {
  const [open, setOpen] = React.useState(false);

  const notify = useNotify();
  const refresh = useRefresh();
  const unselectAll = useUnselectAll("freeSubscriptions");
  const { total, isLoading } = useListContext();

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  if (isLoading || (typeof total === "number" && total > 0)) {
    return null;
  }

  return (
    <>
      <Button startIcon={<Add />} onClick={handleOpen} sx={{ mb: 1 }} label="Add"></Button>

      {open && (
        <CreateBase
          resource="freeSubscriptions"
          record={{ userEmail: record.email }}
          mutationOptions={{
            onSuccess: () => {
              notify("ra.notification.created", {
                type: "info",
                messageArgs: { smart_count: 1 },
              });
              refresh();
              unselectAll();
              handleClose();
            },
          }}
        >
          <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
            <DialogTitle>Gift free subscription</DialogTitle>
            <DialogContent>
              <FreeSubscriptionCreateForm redirect={false} />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleClose} label="Cancel"></Button>
            </DialogActions>
          </Dialog>
        </CreateBase>
      )}
    </>
  );
};
const UserFreeSubscriptionActions = (props: any) => {
  return (
    <TopToolbar>
      <UserFreeSubscriptionCreateDialogButton record={props.record} />
    </TopToolbar>
  );
};
export const UserFreeSubscriptionCreate = (props: any) => {
  return (
    <Create record={props.record} resource="freeSubscriptions" redirect={false}>
      <FreeSubscriptionCreateForm />
    </Create>
  );
};

const UserFreeSubscriptionList = (props: any) => {
  return (
    <List
      resource="freeSubscriptions"
      sort={{ field: "subscriptionStart", order: "DESC" }}
      filter={props.filter}
      exporter={false}
      empty={<UserFreeSubscriptionActions record={props.record} />}
      hasCreate={false}
      actions={props.enabled ? <UserFreeSubscriptionActions record={props.record} /> : false}
    >
      <FreeSubscriptionDatagrid bulkActionButtons={false} />
    </List>
  );
};

export default UserFreeSubscriptionList;
